import React from "react";
import Styled, { css } from "styled-components";

import { ITheme, TStyledPropTheme } from "../../interface";

import { useTheme } from "../../context/ThemeProvider";
import { logoFindMeAt, aboutMe, screenSize } from "../../constant";
const { maxWidth } = screenSize

const ContainerQuote = Styled.div<{ $props: { showContent: boolean } }>`
    transition: all 0.5s ease-in-out 0s;
    ${({ $props }) => {
      const { showContent } = $props;
      const translateX = showContent ? 0 : 20;
      const opacity = showContent ? 1 : 0;
      return css`
        transform: translateX(-${translateX}vw);
        opacity: ${opacity};
      `;
    }}
    z-index: 99;
    width: 36vw;
    height: 83%;
    /* background: red; */
    margin: 25vh 5px 5px 7vw;
    padding: 5px;
    font-family: "Instrument Sans", sans-serif;
    pointer-events: none;
    > * {
      pointer-events: auto;
    }
    @media screen and (max-width: ${maxWidth.mediumTablet}) {
      grid-column: span 2;
      order: 2;
      margin: 0;
      width: 97%;
    }
`;

const Greeting = Styled.h2`
    width: max-content;
    font-size: 2em;
    margin: 0;
    @media screen and (max-width: ${maxWidth.mediumPhoneV1}){
      font-size: 1.5em;
    }
`;
const GreetName = Styled.span<TStyledPropTheme>`
    ${({ $props }) => {
      const { colorTheme } = $props;

      return css`
        color: ${colorTheme.hightlightFont};
      `;
    }}
`;
const AboutMe = Styled.p`
  width: 100%;
  text-align: justify;
  line-height: 20px;
  font-size: 15px;
  @media screen and (max-width: ${maxWidth.mediumPhoneV1}) {
    font-size: 12px;
    line-height: 15px;
  }
`;
const FindMe = Styled.ul`
  display: flex;
  flex-direction: row;
  width: 0;
  padding: 0;
`;

const FindMeAt = Styled.li`
  list-style: none;
  padding: 2px;
  margin: 5px;
  &:nth-child(1) {
    margin-left: 0px;
    padding-left: 0px;
  }
`;
const FindMeIcon = Styled.img<{
  $props: {
    theme: ITheme;
    oppositeTheme: ITheme;
  };
}>`
    ${({ $props }) => {
      const { theme, oppositeTheme } = $props;
      return css`
        filter: ${oppositeTheme.colors.cssFilterPrimary};
        &:hover {
          filter: ${theme.colors.cssFilterHighliightFont};
        }
      `;
    }}
    width: 36px;
    height: 36px;
    cursor: pointer;
`;

function LandingMyInfo({ showContent }: { showContent: boolean }) {
  const { theme, oppositeTheme } = useTheme();

  return (
    <ContainerQuote $props={{ showContent }}>
      <Greeting>
        Hi, I'm{" "}
        <GreetName $props={{ colorTheme: theme.colors }}>Rizky Ikbal</GreetName>
      </Greeting>
      <AboutMe>{aboutMe.short}</AboutMe>
      <FindMe>
        {logoFindMeAt.map(({ logo, name, link }) => {
          return (
            <FindMeAt key={`logo-${name}`}>
              <a target="_blank" rel="noopener noreferrer" href={link}>
                <FindMeIcon $props={{ theme, oppositeTheme }} src={logo} />
              </a>
            </FindMeAt>
          );
        })}
      </FindMe>
    </ContainerQuote>
  );
}
export default LandingMyInfo;
